import {withTranslation} from '@wix/yoshi-flow-editor'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {OrderCanceledOwnProps, OrderCanceledRuntimeProps} from './interfaces'
import {OrderCanceled as Presentation} from './order-canceled'

const mapRuntime = ({actions: {navigateToDetails}}: DetailsPageAppProps): OrderCanceledRuntimeProps => ({
  navigateToDetails,
})

export const OrderCanceled = withTranslation()(
  connect<OrderCanceledOwnProps, OrderCanceledRuntimeProps>(mapRuntime)(Presentation),
)
